const Toggle = (()=>{

    const _ToggleConfig = ()=>{
        const AllItems = document.querySelectorAll('.faq-item');
        //Enable first element
        AllItems[0].classList.add('active');
        AllItems[0].style.maxHeight = `${AllItems[0].scrollHeight}px`;

        AllItems.forEach((item, indice)=>{
            const firtsChild = item.querySelector('.faq-question');
            //Item height
            indice > 0 && (item.style.maxHeight = `${firtsChild.scrollHeight}px`);
            //Item event
            item.addEventListener('click', ()=>{

                item.classList.add('active');

                //Remove class active and reset height
                AllItems.forEach((itemNested)=>{
                    itemNested.classList.remove('active');
                    itemNested.style.maxHeight = `${firtsChild.scrollHeight}px`;
                });
                    
                //Add class
                item.classList.add('active');
                item.style.maxHeight = `${item.scrollHeight}px`;

            });
        });
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _ToggleConfig(); } catch (error) { }
        }
    }
})();

/*
*Load global functions
*/
const loadToggleHandlers = ()=>{
    Toggle.setHandleEvent();
}

export { loadToggleHandlers }